import { Epic, Story, Sprint, ProjectSettings } from '../types';

export const mockProjectSettings: ProjectSettings = {
  theme: {
    primary: '#3B82F6',
    secondary: '#8B5CF6',
    accent: '#F59E0B',
    success: '#10B981',
    warning: '#F59E0B',
    error: '#EF4444'
  },
  defaultSprintDuration: 2,
  workingDaysPerWeek: 5
};

export const mockEpics: Epic[] = [
  {
    id: '1',
    key: 'PROJ-100',
    title: 'User Authentication System',
    description: 'Implement comprehensive user authentication with SSO support, including login, logout, password reset, and multi-factor authentication capabilities.',
    status: 'in-progress',
    priority: 'high',
    assignee: 'Sarah Chen',
    storyPoints: 34,
    stories: [],
    startDate: new Date('2024-01-15'),
    endDate: new Date('2024-03-01'),
    color: '#3B82F6'
  },
  {
    id: '2',
    key: 'PROJ-200',
    title: 'API Integration Layer',
    description: 'Build robust API integration with third-party services including payment gateways, notification services, and external data providers.',
    status: 'todo',
    priority: 'high',
    assignee: 'Mike Rodriguez',
    storyPoints: 21,
    stories: [],
    startDate: new Date('2024-02-01'),
    endDate: new Date('2024-03-15'),
    color: '#8B5CF6'
  },
  {
    id: '3',
    key: 'PROJ-300',
    title: 'Analytics Dashboard',
    description: 'Create comprehensive analytics and reporting dashboard with real-time data visualization, custom reports, and export capabilities.',
    status: 'todo',
    priority: 'medium',
    assignee: 'Jennifer Liu',
    storyPoints: 55,
    stories: [],
    startDate: new Date('2024-03-01'),
    endDate: new Date('2024-05-01'),
    color: '#10B981'
  }
];

export const mockStories: Story[] = [
  {
    id: '1',
    key: 'PROJ-101',
    title: 'Login Page Implementation',
    description: 'Create responsive login page with form validation, error handling, and accessibility features',
    status: 'done',
    priority: 'high',
    assignee: 'Sarah Chen',
    storyPoints: 8,
    timeSpent: 12,
    remainingEstimate: 0,
    subtasks: [],
    epicId: '1'
  },
  {
    id: '2',
    key: 'PROJ-102',
    title: 'OAuth Integration',
    description: 'Integrate OAuth providers (Google, GitHub, Microsoft) with secure token handling and refresh mechanisms',
    status: 'in-progress',
    priority: 'high',
    assignee: 'Alex Thompson',
    storyPoints: 13,
    timeSpent: 8,
    remainingEstimate: 16,
    subtasks: [],
    epicId: '1'
  },
  {
    id: '3',
    key: 'PROJ-103',
    title: 'Session Management',
    description: 'Implement secure session handling, token refresh, and automatic logout functionality',
    status: 'todo',
    priority: 'medium',
    assignee: 'Sarah Chen',
    storyPoints: 13,
    timeSpent: 0,
    remainingEstimate: 20,
    subtasks: [],
    epicId: '1'
  },
  {
    id: '4',
    key: 'PROJ-201',
    title: 'REST API Client',
    description: 'Build reusable REST API client with error handling, retry logic, and request/response interceptors',
    status: 'todo',
    priority: 'high',
    assignee: 'Mike Rodriguez',
    storyPoints: 8,
    timeSpent: 0,
    remainingEstimate: 12,
    subtasks: [],
    epicId: '2'
  },
  {
    id: '5',
    key: 'PROJ-202',
    title: 'GraphQL Integration',
    description: 'Add GraphQL support for complex data queries with caching and subscription capabilities',
    status: 'todo',
    priority: 'medium',
    assignee: 'David Park',
    storyPoints: 13,
    timeSpent: 0,
    remainingEstimate: 18,
    subtasks: [],
    epicId: '2'
  },
  {
    id: '6',
    key: 'PROJ-104',
    title: 'Password Reset Flow',
    description: 'Implement secure password reset functionality with email verification and temporary tokens',
    status: 'todo',
    priority: 'medium',
    assignee: 'Sarah Chen',
    storyPoints: 5,
    timeSpent: 0,
    remainingEstimate: 8,
    subtasks: [],
    epicId: '1'
  },
  {
    id: '7',
    key: 'PROJ-105',
    title: 'Multi-Factor Authentication',
    description: 'Add MFA support with TOTP, SMS, and backup codes for enhanced security',
    status: 'todo',
    priority: 'low',
    assignee: 'Alex Thompson',
    storyPoints: 8,
    timeSpent: 0,
    remainingEstimate: 12,
    subtasks: [],
    epicId: '1'
  },
  {
    id: '8',
    key: 'PROJ-203',
    title: 'API Rate Limiting',
    description: 'Implement client-side rate limiting and queue management for API requests',
    status: 'todo',
    priority: 'low',
    assignee: 'Mike Rodriguez',
    storyPoints: 5,
    timeSpent: 0,
    remainingEstimate: 8,
    subtasks: [],
    epicId: '2'
  }
];

export const mockSprints: Sprint[] = [
  {
    id: '1',
    name: 'Sprint 1 - Authentication Foundation',
    goal: 'Complete core user authentication foundation with login page and basic session management. Establish security patterns and user experience standards for the authentication system.',
    startDate: new Date('2024-01-15'),
    endDate: new Date('2024-01-29'),
    status: 'completed',
    stories: ['1'],
    velocity: 8,
    totalPoints: 8,
    completedPoints: 8
  },
  {
    id: '2',
    name: 'Sprint 2 - OAuth & API Foundation',
    goal: 'Implement OAuth integration for social login and establish REST API client foundation. Focus on secure authentication flows and robust API communication patterns.',
    startDate: new Date('2024-01-29'),
    endDate: new Date('2024-02-12'),
    status: 'active',
    stories: ['2', '4', '6'],
    velocity: 0,
    totalPoints: 26,
    completedPoints: 8
  },
  {
    id: '3',
    name: 'Sprint 3 - Advanced Features',
    goal: 'Complete authentication system with session management and advanced API features. Add GraphQL support and enhance security with MFA preparation.',
    startDate: new Date('2024-02-12'),
    endDate: new Date('2024-02-26'),
    status: 'future',
    stories: ['3', '5', '7', '8'],
    velocity: 0,
    totalPoints: 39,
    completedPoints: 0
  }
];